module.exports = __webpack_public_path__ + "assets_app/img/key-5.bb0b485e.svg";